import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ palette }) => ({
    label: {
        display: "flex",
        flexDirection: "column",
    },
    label__main: {
        fontSize: 16,
        color: "#000000",
    },
    label__sub: {
        fontSize: 12,
        color: palette.grey[800],
    },
}));
//# sourceMappingURL=ui_form_control_label.css.js.map